import { LegalEntityDocumentAttachment } from "./legalEntityPractice.state.model";

export class LoadRegisterReport {
  static readonly type = '[LegalEntityPractice] LoadRegisterReport';
  constructor(public legalEntityId: string) {}
}

export class LoadRegisterReportSuccess {
  static readonly type = '[LegalEntityPractice] LoadRegisterReportSuccess';
  constructor(public legalEntityId: string) {}
}

export class LoadRegisterReportFailure {
  static readonly type = '[LegalEntityPractice] LoadRegisterReportFailure';
  constructor(public error: any) {}
}

export class DownloadAttachment {
  static readonly type = '[LegalEntityPractice] DownloadAttachment';
  constructor(public attachment: LegalEntityDocumentAttachment, public legalEntityId: string) {}
}

export class DownloadAttachmentSuccess {
  static readonly type = '[LegalEntityPractice] DownloadAttachmentSuccess';
}

export class DownloadAttachmentFailure {
  static readonly type = '[LegalEntityPractice] DownloadAttachmentFailure';
  constructor(public error: any) {}
}
